<template>
  <!-- Header Menu -->
  <ul class="nav user-menu">
    <!-- Search -->
    <li class="nav-item nav-searchinputs">
      <div class="top-nav-search">
        <a href="javascript:void(0);" class="responsive-search">
          <i class="fa fa-search"></i>
        </a>
        
      </div>
    </li>

   

    <!-- for branch filter -->

    <li class="nav-item dropdown has-arrow main-drop p-1" v-if="this.actionState === 'view'" >
      
      <vue-select :options="branchList"
          :settings="{ settingOption: value, settingOption: value }" 
          v-model="filter"
          placeholder="None" 
          class="fixed-vselect"
          @select="selectBranch" style="width: 250px; border: 1px solid #09B67D; border-radius: 5px;">
      </vue-select>
    </li>




    <!-- /Search -->
    <li class="nav-item nav-item-box">
      <a @click="userGuide()"><vue-feather type="alert-circle"></vue-feather></a>
    </li>
    
   

    <!-- Notifications -->
    <li class="nav-item dropdown nav-item-box">
      <router-link to="notif" class="nav-link">
        <vue-feather type="bell"></vue-feather><span class="badge rounded-pill" v-if="unreadNotif > 0">{{ unreadNotif
        }}</span>
      </router-link>
      
    </li>
    <!-- /Notifications -->
    <li class="nav-item nav-item-box">
      <router-link to="settingsprofile"><vue-feather type="settings"></vue-feather></router-link>
    </li>
    <li class="nav-item dropdown has-arrow main-drop">
      <a href="javascript:void(0);" class="dropdown-toggle nav-link userset" data-bs-toggle="dropdown">
        <span class="user-info">
          <!-- <span class="user-letter">
            <img src="../assets/img/profiles/avator1.jpg" alt="" class="img-fluid" />
          </span> -->
          <span class="user-detail">
            <span class="user-name">{{ nama_user }}</span>
            <span class="user-role">{{ tipe }}</span>
          </span>
        </span>
      </a>
      <div class="dropdown-menu menu-drop-user">
        <div class="profilename">
          
          <router-link class="dropdown-item" to="profile"><vue-feather type="user"></vue-feather>My Profile</router-link>
          <router-link class="dropdown-item" to="settingsprofile"><vue-feather
              type="settings"></vue-feather>Settings</router-link>
          <hr class="m-0" />
          <a class="dropdown-item logout pb-0" @click="logOut">
            <img src="../assets/img/icons/log-out.svg" class="me-2" alt="img" />Logout
          </a>
          
        </div>
      </div>
    </li>
  </ul>
  <!-- /Header Menu -->
</template>

<style>


.select2-container .select2-selection__rendered {
  display: inline-block;               /* allow width constraints */
  max-width: calc(100% - 36px);        /* leave room for caret/clear icon */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-sizing: border-box;
  vertical-align: middle;
  font-size: 12px !important;

}

/* make sure the selection box itself doesn't expand */
.select2-container .select2-selection .select2-container--default {
  overflow: hidden;
  box-sizing: border-box;
}


</style>


<script>
import headernotification from "../assets/json/headernotification.json";
import { logOut, selectedBranch, ShowLoading, CloseLoading, ErrorConnectionTimeOut, base_url, AlertPopup, goPage } from "@/assets/js/function";
import Cookies from "js-cookie";
import axios from "axios";

export default {
  data() {
    return {
      headernotification: headernotification,
      languages: [
        {
          iso: "us",
          language: "us",
          title: "English",
        },
        // {
        //   iso: "bl",
        //   language: "bl",
        //   title: "Francais",
        // },
        // {
        //   iso: "es",
        //   language: "es",
        //   title: "Spanish",
        // },
        // {
        //   iso: "de",
        //   language: "de",
        //   title: "German",
        // },
      ],
      get unreadNotif() {
        return parseInt(localStorage.getItem('unreadNotif')) || 0;
      },
      set unreadNotif(value) {
        localStorage.setItem('unreadNotif', value);
      },

      //data
      branchList: [],
      companyselected: "",
      filter: 0,

      config: "",
      api: "",
      //token
      token: "",

      actionState: localStorage.getItem('actionState')

    };
  },
  props: {
    nama_user: String,
    tipe: String,
    companyList: Object,
    companyselected: String,
  },

  emits: ["companyselected"],

  computed: {
    selectedBranchLabel() {
      const match = this.branchList.find(item => String(item.id) === String(this.filter));
      return match ? match.text : 'All Branch';
    }
  },
  created() {
    this.token = Cookies.get("token_refresh");
    Cookies.set("token_refresh_utama", this.token);
    this.config = {
        headers: { Authorization: `Bearer ` + this.token },
        timeout: 30000,
    }
    if (localStorage.getItem('unreadNotif') == null) {
      localStorage.setItem('unreadNotif', 0);
    }
    const selectedBranch = localStorage.getItem("selectedBranch");
    if(selectedBranch != null || selectedBranch != undefined || selectedBranch != ''){
        this.filter = selectedBranch;
    }

    
    
    this.getBranchFromIndex();
  },
  methods: {
    logOut,
    
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    userGuide() {
      window.open('https://support.arthaskyline.com/', "_blank");
    },
    selectBranch(item) {
      this.filter = item.id;
      console.log('ini isi branch', item)
      localStorage.setItem("selectedBranch", item.id);
      localStorage.setItem("namaCompany", item.text);
      
      // this.$router.go(0);
      selectedBranch.value = item.id
    },


    // for branch select
    getBranchFromIndex() {
        const raw = localStorage.getItem("company_list");
        if (!raw) return;

        try {
          const parsed = JSON.parse(raw); // convert JSON string to array
          this.branchList = [];

          // Push "All Branch" first
          // this.branchList.push({ id: 0, text: "All Branch"});

          // Push each company from localStorage
          parsed.forEach(item => {
            const item_prepare = {
              id: item.id,
              text: item.nama_lokasi,
              
            };
            this.branchList.push(item_prepare);
          });

          // Optional: set default selected branch from localStorage
          const storedBranch = localStorage.getItem("selectedBranch");
          const exists = this.branchList.some(
            branch => String(branch.id) === String(storedBranch)
          );

          if (exists) {
            this.filter = storedBranch;
          } else {
            this.filter = 0;
            localStorage.setItem("selectedBranch", this.filter);
          }

        } catch (e) {
          console.error("Invalid JSON in company_list:", e);
        }

    },
  },

};
</script>

